import AxiosConfig from '../../../config/AxiosConfig';

const useCheckDecomposition = () => {
  const checkDecomposition = async (lines) => {
    try {
      const response = await AxiosConfig.create('post', `/checkdecomposition/`)
        .call({ lines })
        .getResponseData();

      return response;
    } catch (err) {
      console.error('Échec de la vérification de décomposition :', err);
      throw new Error(`checkDecomposition failed: ${err?.message}`);
    }
  };

  return {
    checkDecomposition,
  };
};

export default useCheckDecomposition;
